<template>
    <div class="van-cell icon-container">
        <div class="thumb" :style="{ width: size, height: size }">
            <img :src="icon" alt=""/>
        </div>
        <div class="desc">
            <div class="desc-filename">
                <span class="filename">{{ showfilename }}</span><span class="metas"><van-tag v-for="(meta, idx) in metas" :key="idx" :color="meta.color" plain>{{ meta.showVal }}</van-tag></span>
            </div>
            <div v-if="moreinfo" class="desc-info" v-html="moreinfotxtHTML"></div>
            <div v-show="false" class="desc-info">{{ moreinfotxt }}</div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "kabala-fileicon",
    props: {
        // 当前文件节点信息
        node: {
            type: Object,
            default: null,
        },
        // 左侧文件图标大小
        size: {
            type: String,
            default: "13.33vw",
        },
        moreinfo: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        showfilename() {
            var fileName = this.getFileName(this.node);
            if (this.node.isfile) {
                return this.buildnodename(fileName);
            } else {
                return this.builddirname(fileName);
            }
        },
        icon() {
            return this.getFileIcon(this.node);
        },
        fileUser() {
            return this.getFileUser(this.node);
        },
        fileTime() {
            return this.getFileTime(this.node);
        },
        fileSize() {
            return this.getFileSize(this.node);
        },
        moreinfotxt() {
            return this.getmoreinfo(this.node);
        },
    },
    data() {
        return {
            moreinfotxtHTML: "",
            metas: [],
        };
    },
    methods: {
        getFileUser(node) {
            try {
                if (node.cuser == undefined || node.cuser.length == 0) {
                    return this.$t("pan.text.system");
                } else {
                    return this.$kuser.getname(node.cuser);
                }
            } catch (e) {
                return "";
            }
        },
        getFileTime(node) {
            if (node.isfile) {
                if (node.versions.length > 0) {
                    var timenum = node.versions[0].vtime;
                    if (timenum == undefined || timenum < 0) {
                        return "";
                    }
                    var mydate = this.$kutil.formatDateObject(timenum, undefined);
                    return moment(mydate).format("YYYY-MM-DD");
                } else {
                    return "";
                }
            } else {
                var timenum = node.ctime;
                if (timenum == undefined || timenum < 0) {
                    return "";
                }
                var mydate = this.$kutil.formatDateObject(timenum, undefined);
                return moment(mydate).format("YYYY-MM-DD");
            }
        },
        getFileSize(node) {
            if (node.isfile) {
                return this.$kutil.formatSize(node.versions[0].datasize);
            } else {
                return "";
            }
        },
        getFileName(node) {
            if (node && node.path) {
                if (node.showpath) {
                    return node.showpath.substring(node.showpath.lastIndexOf("/") + 1);
                } else {
                    return (node.filename = node.path.substring(
                        node.path.lastIndexOf("/") + 1
                    ));
                }
            } else {
                return "UNKNOW";
            }
        },
        getFileIcon(node) {
            if (!node.isfile) {
                return "/kabala/images/mobile/folder.png";
            }
            return this.$kutil.iconUrl2(node.path, 64);
        },
        getmoreinfo(node) {
            var tempStr = "";
            var temp    = [];
            if (node.isfile) {
                if (this.fileSize && this.fileSize.length > 0) {
                    temp.push(this.fileSize);
                }
                if (this.fileUser && this.fileUser.length > 0) {
                    temp.push(this.fileUser);
                }
                if (this.fileTime && this.fileTime.length > 0) {
                    temp.push(this.fileTime);
                }
                tempStr = temp.join(" <b>·</b> ");
            } else {
                if (this.fileUser && this.fileUser.length > 0) {
                    temp.push(this.fileUser);
                }
                if (this.fileTime && this.fileTime.length > 0) {
                    temp.push(this.fileTime);
                }
                tempStr = temp.join(" <b>·</b> ");
            }
            this.moreinfotxtHTML = [
                '<span>',
                tempStr,
                "</span>",
            ].join("");
            return "";
        },

        // 处理文件名称过长
        buildnodename: function (fileName) {
            // console.log("处理名称过长", fileName);
            var showFileName = "";
            var disLength    = fileName.length;
            var substringC   = 10;
            var nameLength   = 0;
            var cutIndex     = 0;
            for (var i = 0; i < disLength; i++) {
                if (escape(fileName[i]).indexOf("%u") < 0) {
                    //不是中文
                    nameLength += 1;
                } else {
                    //中文
                    nameLength += 2;
                }
                if (nameLength > 12) {
                    cutIndex = i;
                    break;
                }
            }

            // console.log(fileName, nameLength > substringC);
            if (nameLength > substringC) {
                showFileName = fileName.replace(
                    /^(^.{8})(.+)(.{5}\.+\w+$)$/g,
                    "$1...$3"
                );
            } else {
                showFileName = fileName;
            }
            return showFileName;
        },
        // 处理文件夹名称过长
        builddirname: function (fileName) {
            // console.log("处理名称过长", fileName);
            var showFileName = "";
            var disLength    = fileName.length;
            var substringC   = 10;
            var nameLength   = 0;
            var cutIndex     = 0;
            for (var i = 0; i < disLength; i++) {
                if (escape(fileName[i]).indexOf("%u") < 0) {
                    //不是中文
                    nameLength += 1;
                } else {
                    //中文
                    nameLength += 2;
                }
                if (nameLength > 12) {
                    cutIndex = i;
                    break;
                }
            }
            // /^(^.{8})(.+)(.{5}\.+\w+$)$/g,
            // console.log(fileName, nameLength > substringC);
            if (nameLength > substringC) {
                showFileName = fileName.replace(/^(^.{8})(.+)(.{9}$)$/g, "$1...$3");
            } else {
                showFileName = fileName;
            }
            return showFileName;
        },

        // 标签
        buildMetas: function () {
            const node = this.node;
            if (node.isfile && node.metas) {
                try {
                    let metas_key_index = {};
                    let metas           = node.metas;
                    for (var j = 0; j < metas.length; j++) {
                        if (metas[j].key == 'sysstatus') { // 流程状态
                            metas_key_index[metas[j].key] = metas[j].value;
                            break;
                        }
                    }
                    node.metas_key_index = metas_key_index;
                } catch (e) {
                }

                if( node.metas_key_index && node.metas_key_index.sysstatus){
                    let sysstatus = (typeof node.metas_key_index.sysstatus) == 'string' ?node.metas_key_index.sysstatus.split("@"):[];
                    let showVal = sysstatus[0] ? sysstatus[0]:'';
                    let color = sysstatus[1] ? sysstatus[1]: 'blue';
                    if(showVal){
                        this.metas = [{
                            color,
                            showVal
                        }];
                    }
                }
            }
        },
    },
    created() {
        this.buildMetas();
    },
};
</script>

<style scoped>
.icon-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    background: transparent;
}

.desc {
    width: 80%;
}

.thumb {
    display: flex;
    width: 30px;
    margin-right: 10px;
}

.thumb img {
    width: 100%;
}

.desc-filename {
    font-size: 4.266667vw;
    color: #333;
    display: flex;
}
.desc-filename .filename{
    height: 24px;
    overflow: hidden;
}
.desc-filename .metas{
    margin-left:0.5em;
    flex-shrink: 0;
}
.desc-info {
    margin-top: 5px;
    font-size: 3.73333vw;
    color: #d3d7d4;
    line-height: 1em;
}

@media screen and (min-width: 450px){
  .desc-filename {
    font-size: 18px;
  }
  .desc-info {
    font-size: 14px;
  }
}

</style>
